<template>
	<div id="app">
		<keep-alive>
		  <router-view v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>
		<van-tabbar v-model="active" class="active_tab" v-if="$route.meta.showTabbar == true ? true : false">
		  <van-tabbar-item
		    v-for="(item,index) in tabbars"
		    :key="index"
		    @click="tab(index,item.name)"
		  >
		    <span :class="currIndex == index ? active:''">{{item.title}}</span>
		    <template slot="icon" slot-scope="props">
		      <img :src="props.active ? item.active : item.normal">
		    </template>
		  </van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
	import readbookVue from './views/readbook/readbook.vue';
	var curComponent;
	export default {
		name: 'app',
		components: {
			readbookVue
		},
		data(){
			return{
				currIndex: 2,
				active: 2,
				tabbars: [
					{
						name: "searchPage",
						title: "搜索",
						normal: require("./assets/tabbar/search.png"),
						active: require("./assets/tabbar/search_active.png")
					},
					{
						name: "bookshelf",
						title: "书架",
						normal: require("./assets/tabbar/bookshelf.png"),
						active: require("./assets/tabbar/bookshelf_active.png")
					},
					{
						name: "bookcity",
						title: "书城",
						normal: require("./assets/tabbar/bookcity.png"),
						active: require("./assets/tabbar/bookcity_active.png")
					},
					{
						name: "forum",
						title: "论坛",
						normal: require("./assets/tabbar/forum.png"),
						active: require("./assets/tabbar/forum_active.png")
					},
					{
						name: "userinfo",
						title: "",
						normal: JSON.parse(sessionStorage.getItem('vuex')) != undefined ? JSON.parse(sessionStorage.getItem('vuex')).loginUserImg : require("./assets/tabbar/userimg.png"),
						active: JSON.parse(sessionStorage.getItem('vuex')) != undefined ? JSON.parse(sessionStorage.getItem('vuex')).loginUserImg : require("./assets/tabbar/userimg.png"),
					}
				],
			}
		},
		watch:{
			'$store.state.loginUserImg': function(){
				for(var i = 0; i< this.tabbars.length ; i++){
						this.tabbars[4].normal = this.$store.state.loginUserImg != null ? this.$store.state.loginUserImg : require("./assets/tabbar/userimg.png");
						this.tabbars[4].active = this.$store.state.loginUserImg != null ? this.$store.state.loginUserImg : require("./assets/tabbar/userimg.png");
				}
			},
			'$route': {
				handler(to){
					const tabIndexMap = {
						'/searchPage': 0,      // 搜索
						'/bookshelf': 1,       // 书架
						'/bookshelfindex': 1,  // 书架相关页
						'/bookdy': 1,          // 书单页
						'/bookcity': 2,        // 书城
						'/forum': 3,           // 论坛
						'/userinfo': 4         // 我的
					};
					const idx = tabIndexMap[to.path];
					if(idx !== undefined){
						this.active = idx;
						this.currIndex = idx;
					}
				},
				immediate: true
			}
		},
		created() {
			//2026-10-12统一watch监听$route当前页面
			//this.active = this.$route.query.tabActive || 2;
			//this.currIndex = this.$route.query.tabActive || 2;
			// if(JSON.parse(sessionStorage.getItem('vuex')) != null){
				
			// }
			// 电量条
			if (this.$webapp.isAndroid) {
				console.log("安卓")
				let isdark = 1;
				this.range = window.android.setBarcolor(Boolean(isdark)); //获取亮度 --- 安卓
			} else if (this.$webapp.isiOS) {
				console.log("苹果")
				// window.webkit.messageHandlers.loginwx.postMessage('') // 苹果
			}
		},
		methods: {
		  tab(index, val) {
		    this.currIndex = index;
		    this.$router.push(val);
		  },
		  setComponent: function (component) {
		    curComponent = component;
		  }
		},
	}
	window["callJsFunc"] = function () {
	    curComponent.callJsFunc();
	}
	window["callJsFuncTTS"] = function () {
	    curComponent.callJsFuncTTS();
	}
	window["callJsFuncPay"] = function () {
	    curComponent.callJsFuncPay();
	}
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #5c5d58;
		font-size: 22px;
		/*px*/
		height: 100vh;
		background: #fff;
	}
	.van-tabbar{
		z-index: 100 !important;
	}
	.van-tabbar-item:last-child .van-tabbar-item__icon img {
		width: 68px;
		height: 68px;
		border-radius: 50%;
		-webkit-box-shadow: 0 0 2px 0 rgba(0,0,0,.3);/*no*/
		-moz-box-shadow: 0 0 2px 0 rgba(0,0,0,.3);/*no*/
		box-shadow: 0 0 2px 0 rgba(0,0,0,.3);/*no*/
	}
	.van-tabbar-item .van-tabbar-item__icon{
		margin-bottom: 8px;/*no*/
	}
	.van-tabbar-item:last-child{
		position: relative;
	}
	.van-tabbar-item:last-child .van-tabbar-item__icon {
		margin-bottom: 0;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
	}
	/deep/input,
	/deep/input::placeholder,
	/deep/textarea::placeholder,
	/deep/textarea{
		font-size: 26px !important;/*px*/
	}
	/deep/input::-webkit-input-placeholder,
	/deep/textarea::-webkit-input-placeholder{ /* WebKit, Blink, Edge */
	   font-size: 26px !important;/*px*/
	}
	/deep/textarea::-moz-placeholder,
	/deep/input::-moz-placeholder { /* Mozilla Firefox 4 to 18 */
	   font-size: 26px !important;/*px*/
	}
	/deep/input::-moz-placeholder,
	/deep/textarea::-moz-placeholder{ /* Mozilla Firefox 19+ */
	   font-size: 26px !important;/*px*/
	}
	/deep/input::-ms-input-placeholder ,
	/deep/textarea::-ms-input-placeholder,{ /* Internet Explorer 10-11 */
	   font-size: 26px !important;/*px*/
	}
	* {
		margin: 0;
		padding: 0;
	}

	ul {
		list-style: none;
	}

	a {
		text-decoration: none;
		color: #9a9a9a;
	}

	input {
		border: 0;
	}

	input[type="text"]::placeholder {
		font-size: 26px;
		/*px*/
	}

	input[type="password"]::placeholder {
		font-size: 26px;
		/*px*/
	}

	.van-tabbar-item--active {
		color: #ff4081 !important;
	}

	.van-tabbar-item__icon {
		margin-bottom: 0;
	}

	.van-tabbar-item__icon img {
		width: 40px;
		/*px*/
		height: 40px;
		/*px*/
	}
	/deep/.van-dialog__confirm,
	/deep/.van-dialog__confirm:active {
		color: #ff4081;
	}
</style>
